import { render, staticRenderFns } from "./VacationAnnouncements.vue?vue&type=template&id=7b80dfe7&scoped=true&"
import script from "./VacationAnnouncements.vue?vue&type=script&lang=js&"
export * from "./VacationAnnouncements.vue?vue&type=script&lang=js&"
import style0 from "./VacationAnnouncements.vue?vue&type=style&index=0&id=7b80dfe7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80dfe7",
  null
  
)

export default component.exports